import { useState, useEffect, ReactNode } from 'react';
import { supabase } from '../../lib/supabase';
import { useAppDispatch, useAppSelector } from '../../state/store';
import { setUser } from '../../state/features/app';
import styles from './styles.module.scss';

interface AuthWrapperProps {
    children: ReactNode;
}

export default function AuthWrapper({ children }: AuthWrapperProps) {
    const user = useAppSelector((state) => state.app.user);
    const [loading, setLoading] = useState(true);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [authError, setAuthError] = useState<string | null>(null);
    const dispatch = useAppDispatch();

    useEffect(() => {
        // Get initial session
        supabase.auth.getSession().then(({ data: { session } }) => {
            const currentUser = session?.user ?? null;
            dispatch(setUser(currentUser));
            setLoading(false);
        });

        // Listen for auth changes
        const {
            data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, session) => {
            const currentUser = session?.user ?? null;
            dispatch(setUser(currentUser));
            setLoading(false);
        });

        return () => subscription.unsubscribe();
    }, [dispatch]);

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setAuthError(null);

        const { error } = await supabase.auth.signInWithPassword({
            email,
            password,
        });

        if (error) {
            setAuthError(error.message);
        }
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!user) {
        return (
            <div className={styles.wrapper}>
                <div className={styles.col}>
                    <div className={styles.title}>毎日</div>
                    <form className={styles.form} onSubmit={handleLogin}>
                        <input
                            type="email"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="メールアドレス"
                        />
                        <br />
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="パスワード"
                        />
                        <br />
                        <button type="submit" className={styles.loginButton}>
                            ログイン
                        </button>
                        <div className={styles.errorWrapper}>
                            {authError && <div className={styles.errorMessage}>{authError}</div>}
                        </div>
                    </form>
                </div>
                <div className={styles.spine}></div>
                <div className={styles.col}></div>
            </div>
        );
    }

    return <>{children}</>;
}
